<template>
    <!--<v-footer>-->
    <!--<v-bottom-nav absolute :value="true" :active.sync="e1" class="transparent">-->
    <v-bottom-nav :value="true" :active.sync="current" class="mildly_purple">
        <v-btn flat value="me">
            <span>me</span>
            <v-icon>person</v-icon>
        </v-btn>

        <v-btn flat value="discover">
            <span>discover</span>
            <v-icon>dashboard</v-icon>
        </v-btn>

        <v-btn flat value="vault">
            <span>Vault</span>
            <v-icon>storage</v-icon>
        </v-btn>

        <v-btn flat value="consents">
            <span>Consents</span>
            <v-icon>swap_calls</v-icon>
        </v-btn>

    </v-bottom-nav>
    <!--</v-footer>-->
</template>

<script>
    export default {
        name: 'footer-navigation',
        computed: {
            current: {
                //eslint-disable-next-line
                get: function() {
                    return this.$store.state.route.name;
                },
                //eslint-disable-next-line
                set: function(v) {
                    this.$router.push({ name: v });
                },
            },
        },
        methods: {},
    };
</script>

<style>
.mildly_purple {
    background: rgb(245, 244, 247);
}

.application--light .mildly_purple .btn {
    color: rgb(51, 48, 88);
}
</style>



// WEBPACK FOOTER //
// FooterNavigation.vue?6dd32b53